import React from 'react';
import SpaceDashboardIcon from '@mui/icons-material/SpaceDashboard';
import { Box, Grid, Typography } from '@material-ui/core';
import { useFiltrosDashboardPichincha } from '../../../store/useFiltersDashboardPichincha';
import { Filtros } from './Filter';
import { GaugeGraphs } from './GaugeGraphs';
import { HelpPopover } from './HelpPopover';
import { Alert } from '@material-ui/lab';
import { AvailabilityChart } from "./AvailabilityChart";

import { useTranslation } from 'react-i18next';
export function DisponibilidadView() {
  const { t } = useTranslation();
  const objetivo = useFiltrosDashboardPichincha((state) => state.objetivo);

  return (
    <Box>
      <Box display="flex" alignItems="center">
        <SpaceDashboardIcon fontSize="medium" />
        <Typography variant="h5" fontWeight="bold">
          {t('sync.availability.dashboard.title')}
        </Typography>
      </Box>
      <Typography variant="subtitle1">
        {t('sync.availability.dashboard.subtitle')}
      </Typography>
      <Box display="flex" justifyContent="flex-end">
        <HelpPopover />
      </Box>
      <Filtros />
      {!objetivo && (
        <Alert severity="warning" style={{ marginTop: 20 }}>
          {t('sync.availability.dashboard.alert.selectObjective')}
        </Alert>
      )}
      <Grid container spacing={2} marginTop={5}>
        <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
          <GaugeGraphs />
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
          <AvailabilityChart />
        </Grid>
      </Grid>
    </Box>
  );
}

export default DisponibilidadView;
